import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Tenant } from 'src/app/core/model/tenants/tenant.model';
import { TenantClientService } from 'src/app/core/services/tenant-client.service';
import { TenantHistoryService } from 'src/app/core/services/tenant-history.service';
import { environment } from 'src/environments/environment';
import { getDefaultLogo } from 'src/app/core/utils/default-logo.util';

@Component({
    selector: 'app-tenant-list',
    templateUrl: './tenant-list.component.html',
    styleUrls: ['./tenant-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenantListComponent implements OnInit {
  tenants: Tenant[] = [];

  constructor(
    private api: TenantClientService,
    private router: Router,
    private route: ActivatedRoute,
    private history: TenantHistoryService
  ) { }

  ngOnInit(): void {
    this.api.getTenants().subscribe(tenants => {
      const choose = this.route.snapshot.queryParamMap.has('choose');

      if (!choose) {
        if (tenants.length === 1) {
          this.navigateTo(tenants[0].tenantCode);
          return;
        }

        const lastUsed = this.history.getLastUsed();
        const match = tenants.find(t => t.tenantCode === lastUsed);
        if (match) {
          this.navigateTo(match.tenantCode);
          return;
        }
      }

      this.tenants = this.sortByHistory(tenants);
    });
  }

  navigateTo(tenantCode: string): void {
    this.history.recordVisit(tenantCode);
    this.router.navigate(['/', tenantCode]);
  }

  getLogo(tenant: Tenant): string {
    return tenant.logo ? environment.apiUrl + tenant.logo : getDefaultLogo();
  }

  private sortByHistory(tenants: Tenant[]): Tenant[] {
    const order = this.history.getHistory();
    return [...tenants].sort((a, b) => {
      const ai = order.indexOf(a.tenantCode);
      const bi = order.indexOf(b.tenantCode);
      if (ai === -1 && bi === -1) return 0;
      if (ai === -1) return 1;
      if (bi === -1) return -1;
      return ai - bi;
    });
  }
}
